var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"icon",style:(_vm.styles),attrs:{"role":"presentation","symbol":_vm.symbol,"size":_vm.width && _vm.height ? `0 0 ${_vm.width} ${_vm.height}` : `0 0 ${_vm.size} ${_vm.size}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }